import { useNav, useQueryParams } from "@pomle/react-router-paths";
import { useMemo } from "react";
import { useDiscountTokenQuery } from "render/hooks/api/queries/useDiscountTokenQuery";
import { useOrderQuery } from "render/hooks/api/useOrder";
import { paths, queries } from "render/routes/paths";
import { BurgerLayout } from "render/ui/layout/BurgerLayout";
import { FullScreenPageLayout } from "render/ui/layout/FullScreenPageLayout";
import { LogoHeader } from "render/ui/layout/LogoHeader";
import { Typography } from "render/ui/presentation/Typography";
import { ActionButton } from "render/ui/trigger/ActionButton";
import styles from "./styles.module.sass";
import { Trans } from "./trans";

export function CheckoutSuccessView() {
  const [params] = useQueryParams(queries.checkout);

  const nav = {
    home: useNav(paths.root),
    booking: useNav(paths.booking),
  };

  const {
    data: order,
    isSuccess: isOrderFetched,
    isLoading: isOrderLoading,
  } = useOrderQuery(params.orderId[0], { enabled: params.orderId[0] != null });

  const discountCode = useMemo(() => {
    if (!isOrderFetched) {
      return null;
    }

    if (order.cart?.discountCodes && order.cart?.discountCodes.length > 0) {
      return order.cart?.discountCodes[0];
    }

    return null;
  }, [order, isOrderFetched]);

  const { data: discountTokenData, isSuccess: isDiscountTokenFetched } =
    useDiscountTokenQuery(discountCode!, { enabled: discountCode != null });

  const isFreeOrder = useMemo(() => {
    if (!isOrderFetched) {
      return false;
    }
    return order.cart?.cartTotal === 0;
  }, [order, isOrderFetched]);

  const isPlaceboOrder = useMemo(() => {
    if (!isOrderFetched || !isDiscountTokenFetched) {
      return false;
    }
    return discountTokenData?.tags?.includes("placebo");
  }, [isOrderFetched, isDiscountTokenFetched, discountTokenData]);

  return (
    <FullScreenPageLayout>
      <BurgerLayout>
        <LogoHeader />
        <div className={styles.body}>
          <div className={styles.content}>
            {!isOrderLoading && (
              <div>
                <Typography variant="title-large">
                  <Trans.AllSet />
                </Typography>
                <Typography
                  variant="title-small"
                  style={{ margin: "12px 0" }}
                  color="subtle"
                >
                  {discountCode && (isPlaceboOrder || isFreeOrder) ? (
                    <Trans.CaptureConfirmation />
                  ) : (
                    <Trans.ConfirmationSentViaEmail />
                  )}
                </Typography>
                <div className={styles.actions}>
                  <ActionButton onClick={nav.home.on({})}>
                    <Trans.NextButton />
                  </ActionButton>
                </div>
              </div>
            )}
          </div>
        </div>
        {null}
      </BurgerLayout>
    </FullScreenPageLayout>
  );
}
